import Parse from "parse";













export class UserReport extends Parse.Object {
  constructor(data) {
    super("RideSharingUserReport", data );
  }
}

Parse.Object.registerSubclass("RideSharingUserReport", UserReport);
